import { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The app page's panel head holds the page's own action (Add a test user,
 * Run evaluations, Money →), as the approved mockup does. The panel bodies
 * live in separate components, so the head exposes a slot and a page drops
 * its action into it. Outside the app page (the embedded dashboard) there is
 * no slot, and the action renders where it stands.
 */
export const PanelActionsSlot = createContext(null);

export default function PanelActions({ children }) {
  const slot = useContext(PanelActionsSlot);
  return slot ? createPortal(children, slot) : children;
}
